import React from 'react';
import Spacer from 'features/shared/Spacer';
import { Plate, Container, Header, Text, SubHeader, FakePlate } from 'features/shared/ui/Page';
import Banner from 'features/webinars/banner';
import UnauthorizedLayout from 'features/shared/layouts/unauthorized';
import { useGetWebinar } from 'features/webinars/useWebinarStore';
import Schedule from 'features/webinars/schedule';
import { UnauthPlateText } from 'features/shared/UnauthPlateText';

const Webinars = () => {
  const { loaded, availableTabs, activeTab, webinarsInMonth, months, getDowloadPath, setTab } = useGetWebinar(0);

  return (
    <UnauthorizedLayout>
      <Container>
        <Header>Обучение учителей</Header>
        <Spacer size={24} />
        <Text style={{ paddingLeft: 24 }}>
          В целях развития профессиональных компетенций учителей на платформе Учи.ру
          <br /> регулярно проводятся вебинары с привлечением экспертов в сфере образования
        </Text>
        <Spacer size={40} />
        <Plate data-qa-id="summary_results_block">
          <SubHeader>Суммарные показатели</SubHeader>
          <Spacer size={24} />
          <FakePlate style={{ padding: 28 }}>
            <UnauthPlateText />
          </FakePlate>
        </Plate>
        <Spacer size={40} />
        <Banner link={getDowloadPath(0, activeTab.id)} />
        <Spacer size={40} />
        <Schedule
          activeTab={activeTab}
          setTab={setTab}
          loaded={loaded}
          months={months}
          webinarsInMonth={webinarsInMonth}
        />
      </Container>
    </UnauthorizedLayout>
  );
};

export default Webinars;
